// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/ppl-flight-training-composition.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/ppl-flight-training-composition/ppl-cross-category-credit-caps.js';
import g1 from '../lessons/air-law/ppl-flight-training-composition/ppl-flight-training-composition.js';

mount([g0, g1]);
